import { render, staticRenderFns } from "./maintainanceStandardItemList.vue?vue&type=template&id=851ffbd0&scoped=true"
import script from "./maintainanceStandardItemList.vue?vue&type=script&lang=js"
export * from "./maintainanceStandardItemList.vue?vue&type=script&lang=js"
import style0 from "./maintainanceStandardItemList.vue?vue&type=style&index=0&id=851ffbd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851ffbd0",
  null
  
)

export default component.exports